import api from './api';
import types from './mutation-types';
import moment from 'moment';

function getRowKey() {
	return moment.now().toString();
}

export default {
	onClickSearch_({ state, commit, dispatch }) {
		return dispatch('searchTaskCommCdMst_').then(() => commit(types.SET, { key: 'taskCommCdRows', value: [] }));
	},
	searchTaskCommCdMstOptions_({ state, dispatch, commit }) {
		
		return api
			.selectTaskCommCdMstList({ ...state.searchParam, currentPage: 0, pageUnit: 0 })
			.then(({ body: { result }, header }) => {
				result.forEach(row => delete row.totalSize);
				dispatch('setTaskCommCdMstOptions_', result);
				return result;
			})
			.catch(e => console.error(e));
	},
	searchTaskCommCdMst_({ state, commit }, pagination) {
		const pagingInfo = { ...state.taskCommCdMstPagingInfo, ...pagination };
		return api
			.selectTaskCommCdMstList({ ...state.searchParam, ...pagingInfo })
			.then(({ body: { result, pagingInfo }, header }) => {
				result.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'taskCommCdMstRows', value: result });
				commit(types.SET, { key: 'taskCommCdMstPagingInfo', value: pagingInfo });
				commit(types.SET, { key: 'taskCommCdRows', value: [] });
				commit(types.SET, { key: 'currentMstCd', value: '' });
				return result;
			})
			.catch(e => console.error(e));
	},
	setTaskCommCdMstOptions_({ state, commit }, rows) {
		const value = [{ label: 'ALL', value: 'ALL' }].concat(rows.map(({ mstCd }) => ({ label: mstCd, value: mstCd })));
		commit(types.SET, {
			key: 'taskCommCdMstOptions',
			value
		});
		return value;
	},
	searchTaskCommCd_({ state, commit }, payload) {
		const { mstCd, init, currentPage = 1, pageUnit = 10 } = payload;
		return api
			.selectTaskCommCdList({ mstCd, currentPage, pageUnit })
			.then(({ body: { pagingInfo, result } }) => {
				result.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'taskCommCdRows', value: init || result });
				commit(types.SET, { key: 'taskCommCdPagingInfo', value: pagingInfo });
				return result;
			})
			.catch(e => console.error(e));
	},
	setUseYnOptions_({ state, commit }, rows) {
		commit(types.SET, {
			key: 'useYnOptions',
			value: [{ label: 'ALL', value: 'ALL' }].concat(rows.map(({ commCd }) => ({ label: commCd, value: commCd })))
		});
	},
	setCurrentTaskCommCdMst_({ state, commit }, value) {
		commit(types.SET, {
			key: 'currentMstCd',
			value
		});
	},
	addTaskCommCdRow_({ state, commit }) {
		if (!state.currentMstCd) {
			return;
		}
		const rowKey = getRowKey();
		const addedRow = { status: 'I', mstCd: state.currentMstCd, dtlCd: '', useYn: 'Y', rowKey, dtlCdName: '', dtlCdDesc: '', dtlCdSeq: '',ref1Cd: ''};
		const value = [...state.taskCommCdRows, addedRow];
		commit(types.SET, { key: 'taskCommCdRows', value });
		return addedRow;
	},
	addTaskCommCdMstRow_({ state, commit }) {
		const rowKey = getRowKey();
		const addedRow = { status: 'I', mstCd: '', mstCdName: '', mstCdDesc: '', useYn: 'Y', rowKey };
		const value = [...state.taskCommCdMstRows, addedRow];
		commit(types.SET, { key: 'taskCommCdMstRows', value });
		return addedRow;
	},
	onChangeSearchParam_({ state, commit, dispatch }, payload) {
		commit(types.SET_SEARCH_PARAM, payload);
		if (['mstCd', 'useYn'].includes(payload.key)) {
			return dispatch('searchTaskCommCdMst_', { ...state.taskCommCdPagingInfo, currentPage: 1 });
		}
	},
	async saveTaskCommCdMst_({ state, dispatch }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		return api.saveTaskCommCdMst(rows).then(({ header }) => {
			return dispatch(`searchTaskCommCdMst_`, { ...state.taskCommCdPagingInfo }).then(() => header);
		});
	},
	deleteTaskCommCdMst_({ state, dispatch, commit }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		const rowKeys = rows.map(r => r.rowKey);
		const keys = rows.filter(({ status }) => status !== 'I').map(r => r.mstCd);

		if (keys.length === 0) {
			dispatch('deleteAddedTaskCommCdMst_', rowKeys);
			return;
		}
		return api.deleteTaskCommCdMst(rows).then(({ header }) => dispatch('searchTaskCommCdMst_').then(() => header));
	},
	saveTaskCommCd_({ state, dispatch }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		return api.saveTaskCommCd(rows).then(({ header }) => {
			return dispatch(`searchTaskCommCd_`, { ...state.taskCommCdPagingInfo, mstCd: state.currentMstCd }).then(() => header);
		});
	},
	deleteTaskCommCd_({ state, dispatch }, rows) {
		if (!rows || rows.length === 0) {
			return;
		}
		const rowKeys = rows.map(r => r.rowKey);
		const keys = rows.filter(({ status }) => status !== 'I').map(r => r.dtlCd);

		if (keys.length === 0) {
			dispatch('deleteAddedTaskCommCd_', rowKeys);
			return;
		}
		const mstCd = state.currentMstCd;
		return api.deleteTaskCommCd(rows).then(({ header }) => dispatch('searchTaskCommCd_', { mstCd }).then(() => header));
	},
	deleteAddedTaskCommCdMst_({ state, commit }, rowKeys) {
		const value = state.taskCommCdMstRows.filter(({ rowKey }) => !rowKeys.includes(rowKey));
		commit(types.SET, { key: 'taskCommCdMstRows', value });
		return;
	},
	deleteAddedTaskCommCd_({ state, commit }, rowKeys) {
		const value = state.taskCommCdRows.filter(({ rowKey }) => !rowKeys.includes(rowKey));
		commit(types.SET, { key: 'taskCommCdRows', value });
		return;
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	}
};
